import axiosInstance from "../../setupAxios";
import { IAllocationSearchModel } from "../types/IAllocationSearchModel";
import { AllocationHeaderRowType } from "../../repertoire/types/usageTypes/IAllocationRowTypes";
import { DEFAULT_ALLOCATION_SEARCH_PAGE_SIZE } from "../constants/AllocationSearchConstants";
import { getAllocationRows, mapAllocationRow } from "./utils/DatabricksAllocationMapper";

interface AllocationSearchPage {
    rows: AllocationHeaderRowType[];
    continuationToken: number | null;
    hasMore: boolean;
    pageSize: number;
}

export class DatabricksApiService {
    static searchAllocations(searchModel: IAllocationSearchModel): Promise<AllocationSearchPage> {
        return axiosInstance.post("databricks/Allocations/", searchModel).then(res => {
            const data = res.data;
            const rawRows = getAllocationRows(data);

            return {
                rows: rawRows.map((row, index) => mapAllocationRow(row, index)),
                continuationToken: data.continuationToken ?? data.ContinuationToken ?? null,
                hasMore: data.hasMore ?? data.HasMore ?? false,
                pageSize: searchModel.pageSize ?? DEFAULT_ALLOCATION_SEARCH_PAGE_SIZE
            };
        });
    }
}